import { Auth } from 'aws-amplify';
import { CognitoUser } from 'amazon-cognito-identity-js';
import { isNewPasswordRequired } from '../util/validation';
import { storePermission } from 'utils/helpers';

const login = async params => {
  if (params instanceof CognitoUser) {
    return params;
  }

  const { error } = params;

  
  if (error) {
    return Promise.reject(error);
  }

  const { username, password } = params;
  const user = await Auth.signIn(username.trim(), password).catch(error_ => {
    if (
      error_.code === 'NotAuthorizedException' ||
      error_.code === 'UserNotFoundException'
    ) {
      if (error_.message.includes('Incorrect username or password')) {
        return Promise.reject(new Error('error.auth.invalidCredentials'));
      }

      return Promise.reject(new Error('error.auth.unableToLogin'));
    }

    return Promise.reject(error_);
  });

  // Reject with the user if new password is required to allow change in login flow
  if (isNewPasswordRequired(user)) {
    return Promise.reject(user);
  }

  storePermission()

  return user;
};

export default login;
